export default class NumberFormatter {

    public static toCurrency(n: number) {
        const formatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
        return formatter.format(n);
    }

    public static toNumber(n: number, d: number) {
        const formatter = new Intl.NumberFormat('en-US', {
            currency: 'USD',
            minimumFractionDigits: d,
            maximumFractionDigits: d
        });
        return formatter.format(n);
    }

}